import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    z-index: 1;
    align-items: center;
    padding: 40px 0 60px 0;
`;

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: column;
    width: 100%;
    padding: 10px 0px 60px 0;
    gap: 12px;
`;

export const HeaderRow = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    padding: 0 24px;
    margin-bottom: 24px;

    @media (max-width: 1024px) {
        padding: 0 16px;
    }
`;

export const TitleBlock = styled.div`
    flex-shrink: 0;
    white-space: nowrap;
    text-align: center;
`;

export const Title = styled.h2`
    display: inline-block;
    font-size: 76px;
    text-align: left;
    font-weight: 900;
    text-transform: uppercase;
    letter-spacing: -1.5px;
    line-height: 1;
    color: ${({ theme }) => theme.text_primary};
    margin: 0;

    @media (max-width: 1400px) {
        font-size: 64px;
    }

    @media (max-width: 1200px) {
        font-size: 52px;
    }

    @media (max-width: 768px) {
        font-size: 44px;
    }
`;

export const TitleAccent = styled.span`
    display: inline-block;
    font-family: 'Mosca Laroke', 'Playfair Display', 'Bodoni Moda', 'Cinzel', serif;
    font-size: 76px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 1;
    color: ${({ theme }) => theme.primary};
    letter-spacing: 0.5px;

    @media (max-width: 1400px) {
        font-size: 64px;
    }

    @media (max-width: 1200px) {
        font-size: 52px;
    }

    @media (max-width: 768px) {
        font-size: 44px;
        margin-left: 12px;
    }
`;

export const ToggleButtonGroup = styled.div`
    display: flex;
    border: 1.5px solid ${({ theme }) => theme.primary};
    color: ${({ theme }) => theme.primary};
    font-size: 16px;
    border-radius: 12px;
    font-weight: 500;
    margin: 22px 0px;
    @media (max-width: 768px) {
        font-size: 12px;
    }
`

export const ToggleButton = styled.div`
    padding: 8px 18px;
    border-radius: 6px;
    cursor: pointer;
    ${({ active, theme }) =>
        active && `
    background: ${theme.primary + 20};
    `
    }
    &:hover {
        background: ${({ theme }) => theme.primary + 8};
    }
    @media (max-width: 768px) {
        padding: 6px 8px;
        border-radius: 4px;
    }
`
export const Divider = styled.div`
    width: 1.5px;
    background: ${({ theme }) => theme.primary};
`

export const CardContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 18px;
    width: 100%;
    padding: 0 20px;
    margin-top: 32px;

    @media (max-width: 1024px) {
        grid-template-columns: repeat(3, 1fr);
    }
    @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
        padding: 0 12px;
    }
    @media (max-width: 480px) {
        grid-template-columns: 1fr;
        padding: 0 12px;
    }
`;

export const GridColumn = styled.div`
    display: flex;
    flex-direction: column;
    gap: 18px;
    padding-top: ${({ $offset }) => $offset ? '80px' : '0'};

    @media (max-width: 768px) {
        padding-top: ${({ $offset }) => $offset ? '40px' : '0'};
    }
    @media (max-width: 480px) {
        padding-top: 0;
    }
`;
